import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import "./Blog.css";

const Blog = () => {
    const [blogs, setBlogs] = useState([]);

    useEffect(() => {
        const fetchBlogs = async () => {
            try {
                const response = await axios.get("https://baseapis.akari.sa/api/Blog/GetBlogs");
                setBlogs(response.data);
            } catch (err) {
                console.error("Failed to fetch blogs:", err);
            }
        };

        fetchBlogs();
    }, []);

    return (
        <div className="blog-list">
            <h2 className="blog-heading">أخبار ومقالات العقارات</h2>
            <p className="blog-subheading">ابقى على اطلاع بأحدث أخبارنا ومقالاتنا</p>
            <div className="blog-cards">
                {blogs.map((blog) => (
                    <div key={blog.id} className="blog-card">
                        <Link to={`/blogdetails/${blog.id}`}>
                            {blog.image && (
                                <img src={blog.image} alt="Banner" className="blog-image" />
                            )}
                        </Link>
                        <h3>{blog.title}</h3>
                        <div
                            className="blog-content"
                            dangerouslySetInnerHTML={{ __html: blog.content.slice(0, 150) + "..." }}
                        />
                        <p><strong>تاريخ-</strong> {blog.category}</p>
                        <Link to={`/blogdetails/${blog.id}`} className="read-more">اقرأ المزيد</Link>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Blog;
